export default __webpack_public_path__ + "static/media/jap-ecommerceImg_6.a011bf17.webp";